var d1 = null;
var retdays;
window.onload = function() {
//   window['moment-range'].extendMoment(moment);
  function parseDateRange(input2DArray) {
    //get the first and last value of the array
    let firstA = input2DArray[0];
    //let lastA = input2DArray.pop();
    let lastA = input2DArray[input2DArray.length-1];
    //because month values start at 0
    firstA[1]++;
    lastA[1]++;
    //assumes moment.js is loaded
    let first = moment(firstA.join('-'), 'YYYY-MM-DD')
    let last = moment(lastA.join('-'), 'YYYY-MM-DD')
    return {first, last};
  }
  function parse2DArrayToMomentArray(input2DArray) {
    let returnArray = []
    for (var i = 0; i < input2DArray.length; i++) {
      	input2DArray[i][1]++
        let d = moment(input2DArray[i].join('-'), 'YYYY-MM-DD')
    	returnArray.push(d);
    }
    return returnArray;
  }
  // get the modal
  var modal = document.getElementById("dateModal");
  var zipButton = document.getElementById("zipButton");
  var zipInput = document.getElementById("zipInput");
  //create the calendar globally so it doesnt create duplicates
  var calendar
  // get the button that opens the modal
  var btn = document.getElementById("dateBtn");
  // get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];
  // when the user clicks on the button, open the modal
  btn.onclick = function() {
    modal.style.display = "block";
    modal.style.opacity = 1;
  }

  zipButton.onclick = function(event) {
    event.preventDefault(); //prevent form from submitting
	let zipCode = zipInput.value
    let zipRegex = /^\d{5}$/
    if (!zipRegex.test(zipCode)) {
     console.log('not a valid zip')
     return //prevent rest of function from executing
    }
    modal.style.display = "none";
    //do the api call to FedEx here
    //use returned data to update calendar init values
    const postOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify({items:[]})
    };
    let postRequest = fetch('https://prod-test.decimaltest.com/stores/7d5dfde7-8f6c-473d-bd18-511d56284705/dates/valid/' + zipCode, postOptions);
    postRequest.then(response => {
      response.json().then(function(res) {
        let resultArrayCopy = arrayClone(res.result.enabled);
        
        
        let {first, last} = parseDateRange(res.result.enabled);
        let momentArray = parse2DArrayToMomentArray(resultArrayCopy);
        d1 = momentArray;
        
         
// 		two ways to do this...
        
        function checkIsOverLimit(limit , days){
          var i = days.length-1;
          while(days[i].diff(moment() , 'days') > limit){
            days.pop();
            i--;
          }
        	return days;
        }
       	calendar = new mdDateTimePicker.default({
          type: 'date',
          includeDays: checkIsOverLimit(90 , momentArray),
         
          modal: 'dp-wrap'
          
        });
        
        //Edited By Danyal
        var pastDaysToInclude = -1;
        
        var futureDaystoInclude = 120;
        
        var excludeDaysOfWeek = [0,1];//Add Comma Separated Values from 0-6(Sunday-Saturday), Currently Sunday, Monday and Tuesday are Excluded
        
        var enable_left_column = true;
        
        //Add Your Business Holidays and National Hlidays in this list
        var specificDatesToExclude = [
        	
          	moment('2023-11-16','YYYY-MM-DD'),
          	moment('2021-02-26','YYYY-MM-DD'),
            moment('2021-03-29','YYYY-MM-DD'),
            moment('2021-06-01','YYYY-MM-DD'),
            moment('2021-09-04','YYYY-MM-DD'),
            moment('2021-11-25','YYYY-MM-DD'),
            moment('2021-11-26','YYYY-MM-DD'),
            moment('2021-12-25','YYYY-MM-DD'),
            moment('2022-11-23','YYYY-MM-DD'),
            moment('2021-12-31','YYYY-MM-DD'),
            moment('2022-12-27','YYYY-MM-DD'),
            moment('2022-11-25','YYYY-MM-DD'),
            moment('2022-12-24','YYYY-MM-DD'),
            moment('2022-12-30','YYYY-MM-DD'),
            moment('2022-12-31','YYYY-MM-DD'),
          
          
        ];

        var freeExclusionList = [];
        var freeShippingDays = [];

        for (i = 0; i < specificDatesToExclude.length; i++) {
          freeExclusionList.push(specificDatesToExclude[i].format('YYYY-MM-DD'))
        }

        function calcFreeShippingDays(exclusionList){
//           var currentTime = moment();
          var currentTime = moment().tz('America/New_York');
          var addDays = 121;
          var startDay = 2;
//           var freeLogString = "";
          
          // beginning 2 days from today at 2 pm ... and ending 120 days from today

          if (currentTime.format('H') >= 14) {
            currentTime.add(1, 'd')
            addDays = 120
            startDay = 3
          }
          
          var freeDays = [];
          // var stopDate = moment().add(addDays, 'd');
          
          for (i=startDay; i <= addDays; i++) {
            testDate = moment().add(i, 'd')

            // if Wednesday - Friday
            if ( (testDate.day() >= 3 && testDate.day() < 6) ) {
              // and not an excluded date
              if (!(exclusionList.includes(testDate.format('YYYY-MM-DD')))) {
//                 freeLogString += testDate.format('YYYY-MM-DD')
//                 freeLogString += ","
                // add the day to the free day array
                freeDays.push(testDate)
              }
            }
          }
          
//           console.log(`FREE SHIPPING DATES: ${freeLogString}`)
          return freeDays;
        }
        
        freeShippingDays = calcFreeShippingDays(freeExclusionList);

        calendar = new mdDateTimePicker.default({
          type: 				'date',
          past: 			 	momentArray[0],
          future: 			 	moment().add(futureDaystoInclude, 'days'),
          excludeDaysOfWeek: 	excludeDaysOfWeek,
          excludeDays:		 	specificDatesToExclude,
          freeDays:             freeShippingDays,    
          modal: 				'dp-wrap',
//           init:                 moment('04-01-2021')
        });
           
        calendar.toggle();
		
      	const triggerDiv = document.createElement('div');
        
        document.getElementById('dp-wrap').style.zIndex = 100;
		
        calendar.trigger = triggerDiv;
        if(enable_left_column === false){
          document.getElementById('mddtp-date__header').remove();
        }
        triggerDiv.addEventListener('onOk', function(){
          console.log(calendar.time.format('MM-DD-YYYY'));
          //get cart.js here
          $.ajax({
              type: 'get',
              url: '/cart.js',
              dataType: 'json'
           }).then(function(resData) {
            console.log(resData);
            var items= resData.items
            console.log(calendar.time.toISOString())
            console.log(items[0].quantity);
            var line = 1
            if(items[0].handle === "navidium-shipping-protection"){
              line = 2
            }
            var data = {
              line: line,
             	quantity: items[line-1].quantity,
              properties: {
                utc_adjustment: calendar.time.format('YYYY-MM-DD')+'T00:00:00.000Z'
              }
            }
            console.log(JSON.stringify(data))
         	//inserts spinner modal at content_wrapper
            function loadSpinner() {
              node = document.getElementById('PageContainer');
			  node.insertAdjacentHTML('afterbegin', '<div class="spinner-modal"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></div>');
//           	  setTimeout(function() {
//               }, 3000);
            };
            //update cart.js file
            jQuery.ajax({
              type: 'post',
              url: '/cart/change.js',
              data: data,
              success: function(d){
                console.log("SUCCESS")
           		//invoke spinner modal
                loadSpinner();
                //redirect to shopify checkout     	
                setTimeout(function(){document.location.href = "/checkout";},1000);
                console.log(d)
              },
              dataType: 'json'
            });
          });
        });
      });
    });
  }
  // end comment for hot fix
  // when the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modal.style.display = "none";
  }
  // when the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
  function arrayClone( arr ) {
    var i, copy;
    if( Array.isArray( arr ) ) {
        copy = arr.slice( 0 );
        for( i = 0; i < copy.length; i++ ) {
            copy[ i ] = arrayClone( copy[ i ] );
        }
        return copy;
    } else if( typeof arr === 'object' ) {
        throw 'Cannot clone array containing an object!';
    } else {
        return arr;
    }
}
};
// disable "GO" button on iphone and android
$(document).ready(function() {
    $('input').keypress(function(e) {
        var code = (e.keyCode ? e.keyCode : e.which);
        if ( (code==13) || (code==10))
            {
            $(this).blur();
            return false;
            }
    });
});

$(document).ready(function(){
$('.close').click(function(){
$('#dateModal').css('display','none')
})
});